import { toast as sonnerToast } from 'sonner';

import i18n from '@/lib/i18n';

function getMessage(message: string | unknown): string {
  if (Array.isArray(message)) {
    console.error('Toast received an array message:', message);
    return i18n.t('common.error.unknown');
  }
  if (typeof message !== 'string') {
    return i18n.t('common.error.unknown');
  }

  if (message.includes('.') && i18n.exists(message)) {
    return i18n.t(message);
  }
  return message;
}

export function showSuccess(message: string, id?: string) {
  sonnerToast.success(getMessage(message), id ? { id } : undefined);
}

export function showError(message: string, id?: string) {
  sonnerToast.error(getMessage(message), id ? { id } : undefined);
}

export function showInfo(message: string) {
  sonnerToast.info(getMessage(message));
}

export function showWarning(message: string) {
  sonnerToast.warning(getMessage(message));
}

export function showLoading(message: string) {
  return sonnerToast.loading(getMessage(message));
}

export function dismissToast(toastId: string | number) {
  sonnerToast.dismiss(toastId);
}

export { sonnerToast as toast };
